export default "__VITE_ASSET__cb9cd4c1__"